import * as React from "react";
import { StyleSheet } from "react-native";
import { Feather } from "@expo/vector-icons";
import Pressable from "../Pressable";

type Props = {
  name: any;
  size: number;
  color: string;
  onPress?: () => void;
  testingId?: string;
};

export default function Icon(props: Props) {
  const { name, size, color, onPress, testingId } = props;

  return (
    <Pressable testID={testingId} onPress={onPress && onPress}>
      <Feather name={name} color={color} size={size} />
    </Pressable>
  );
}

const styles = StyleSheet.create({});
